//@ts-nocheck
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Typography, Button, Box } from '@mui/material';
import { ReactComponent as NimbusLogo } from '../../assets/Icons/MRMVaultColored.svg';
import { getLabelPathFromLabelConfig } from '../../utils/Utils';
import { DEFAULT_ROUTE_CONFIG } from '../../const/defaultRoutesConfig';

const NotFound404 = () => {
  const history = useNavigate();
  const unselectableStyles = {
    userSelect: 'none',
    WebkitTouchCallout: 'none',
    KhtmlUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
  };
  const handleGoToHome = useCallback(() => {
    const homePath = getLabelPathFromLabelConfig(
      DEFAULT_ROUTE_CONFIG?.home?.keyPath || ``,
      'path',
      DEFAULT_ROUTE_CONFIG?.home?.path
    );

    history(`/${homePath}?value=0`);
  }, [history]);
  return (
    <Grid
      container
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
      }}
    >
      <Grid>
        <Box
          sx={{
            p: 1,
            marginBottom: 2,
          }}
        >
          <NimbusLogo height="100px" width="170px" />
        </Box>
      </Grid>
      <Grid sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          color="primary"
          sx={{
            fontWeight: 'bold',
            fontSize: 300,
            lineHeight: 1,
            ...unselectableStyles,
          }}
        >
          404
        </Typography>
        <Typography
          variant="h5"
          color="primary"
          sx={{
            fontWeight: 'bold',
            fontSize: 20,
            ...unselectableStyles,
          }}
        >
          Not Found
        </Typography>
      </Grid>
      <Grid
        sx={{
          mt: 5,
        }}
      >
        <Button variant="contained" color="primary" onClick={handleGoToHome}>
          Go Back Home
        </Button>
      </Grid>
    </Grid>
  );
};

export default NotFound404;
